const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/eCheckinItems.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { ECheckinWorkItem } from '@cistec/common_web/defs/kisim';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';
import { KeyValuePair, KISIM_TIME_FORMAT, KISIM_TIME_OPEN } from '@cistec/common_web/defs/generalDefs';
import moment from 'moment/moment';

export const LOAD_ECHECKIN_ITEMS = kisapiActionTypes('LOAD_ECHECKIN_ITEMS');
export const CREATE_ECHECKIN = kisapiActionTypes('CREATE_ECHECKIN');
export const UPDATE_ECHECKIN = kisapiActionTypes('UPDATE_ECHECKIN');
export const FINALIZE_ECHECKIN = kisapiActionTypes('FINALIZE_ECHECKIN');

/**
 * Finalizes the WorkItem with the given WORKID, updating the relevant KISIM objects and/or sending part of the
 * e-checkin data to the administration system.
 */
export function actionFinalizeECheckin(workItem: ECheckinWorkItem) {
    const { FALLNR, WORKID, TKEY } = workItem;
    const endpoint = `echeckin/${workItem.WORKID}/finalize`;
    const meta = { workId: WORKID, fallNr: FALLNR, tKey: TKEY };
    return createPatapiCall(FINALIZE_ECHECKIN, endpoint, HttpMethod.POST, meta);
}

export function actionUpdateECheckin(eCheckinWorkItem: ECheckinWorkItem, eCheckinData: KeyValuePair) {
    const { FALLNR, WORKID, ETAG, TKEY } = eCheckinWorkItem;

    const body = {
        FALLNR,
        eCheckinData,
        ETAG,
    };

    const meta = { fallNr: FALLNR, tKey: TKEY };
    const endpoint = `echeckin/${WORKID}`;
    return createPatapiCall(UPDATE_ECHECKIN, endpoint, HttpMethod.POST, meta, JSON.stringify(body));
}

export type ActionUpdateECheckin = ReturnType<typeof actionUpdateECheckin>;

export function actionCreateECheckin(FALLNR: string | undefined, eCheckinData: KeyValuePair) {
    const body = {
        FALLNR,
        eCheckinData,
    };

    const meta = { fallNr: FALLNR };
    const endpoint = `echeckin`;
    return createPatapiCall(CREATE_ECHECKIN, endpoint, HttpMethod.POST, meta, JSON.stringify(body));
}

export type ActionCreateECheckin = ReturnType<typeof actionCreateECheckin>;

const mindat = moment().subtract(4, 'months').format(KISIM_TIME_FORMAT);

export function actionLoadECheckinItems() {
    const params = {
        mindat,
        maxdat: KISIM_TIME_OPEN,
    };

    const queryString = new URLSearchParams(params).toString();
    const endpoint = `echeckin?${queryString}`;

    return createPatapiCall(LOAD_ECHECKIN_ITEMS, endpoint, HttpMethod.GET);
}
